import { render, staticRenderFns } from "./LabelDropdownItem.vue?vue&type=template&id=464204b6&scoped=true&"
import script from "./LabelDropdownItem.vue?vue&type=script&lang=js&"
export * from "./LabelDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./LabelDropdownItem.vue?vue&type=style&index=0&id=464204b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464204b6",
  null
  
)

export default component.exports